const state = {
  typeSalarie: 'INTER', // Entre INTER PERM PIG
}

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
